/**
 * FOSSiBOT variant card picker – updates card prices/images when other options change.
 * Hooks into T4S theme swatch system via variant:changed event.
 */
(function () {
  'use strict';

  var CARD_SELECTOR = '[data-fossibot-variant-card="true"]';
  var CARD_ITEM_CLASS = '.fossibot-variant-card__item';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    var value = (cents / 100).toFixed(2);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch (format.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
    return format.replace(placeholderRegex, value);
  }

  function getMoneyFormat() {
    var cfg = window.T4Sconfigs || {};
    return cfg.moneyFormat || '${{amount}}';
  }

  function getSelectedOptionsMap(container) {
    var map = {};
    container.querySelectorAll('[data-swatch-option]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-id'), 10);
      if (isNaN(idx)) return;
      var selected = el.querySelector('[data-swatch-item].is--selected');
      if (selected) {
        map[idx] = selected.getAttribute('data-value');
      }
    });
    return map;
  }

  function findVariantForCardValue(variants, cardOptionIndex, cardValue, selectedMap) {
    return variants.find(function (variant) {
      if (variant['option' + (cardOptionIndex + 1)] !== cardValue) return false;
      for (var key in selectedMap) {
        if (!Object.prototype.hasOwnProperty.call(selectedMap, key)) continue;
        var i = parseInt(key, 10);
        if (i === cardOptionIndex) continue;
        if (variant['option' + (i + 1)] !== selectedMap[i]) return false;
      }
      return true;
    });
  }

  function getSavePercent(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((compare - price) * 100 / compare);
  }

  function formatSaveBadge(price, compare) {
    var percent = getSavePercent(price, compare);
    return percent > 0 ? percent + '% OFF' : null;
  }

  function updateCardItem(item, variant) {
    if (!variant) return;

    var price = variant.price;
    var compare = variant.compare_at_price || price;
    var moneyFormat = getMoneyFormat();

    item.setAttribute('data-variant-id', variant.id);
    item.setAttribute('data-fossibot-card-price', price);
    item.setAttribute('data-fossibot-card-compare', compare);

    var priceEl = item.querySelector('[data-fossibot-card-price-el]');
    var compareEl = item.querySelector('[data-fossibot-card-compare-el]');
    var saveEl = item.querySelector('[data-fossibot-card-save]');

    if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);

    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatMoney(compare, moneyFormat);
        compareEl.hidden = false;
        compareEl.classList.remove('t4s-d-none');
      } else {
        compareEl.hidden = true;
        compareEl.classList.add('t4s-d-none');
      }
    }

    if (saveEl) {
      var saveText = formatSaveBadge(price, compare);
      if (saveText) {
        saveEl.textContent = saveText;
        item.setAttribute('data-fossibot-card-save-percent', getSavePercent(price, compare));
        saveEl.hidden = false;
        saveEl.classList.remove('t4s-d-none');
      } else {
        item.removeAttribute('data-fossibot-card-save-percent');
        saveEl.hidden = true;
        saveEl.classList.add('t4s-d-none');
      }
    }

    var imageEl = item.querySelector('[data-fossibot-card-image-el]');
    var imageSrc = variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : (variant.image && variant.image.src ? variant.image.src : null);

    if (imageSrc && imageEl && imageEl.tagName === 'IMG') {
      var sizedSrc = imageSrc.replace(/(\?|&)(width|height)=\d+/g, '');
      var separator = sizedSrc.indexOf('?') >= 0 ? '&' : '?';
      imageEl.src = sizedSrc + separator + 'width=160';
    }

    item.classList.toggle('is--soldout', !variant.available);
  }

  function refreshCardOption(container, cardOptionIndex) {
    var cardOption = container.querySelector('[data-swatch-option]' + CARD_SELECTOR);
    if (!cardOption) return;

    var variantsJson = container.querySelector('.pr_variants_json');
    if (!variantsJson) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var selectedMap = getSelectedOptionsMap(container);
    var cardItems = cardOption.querySelectorAll(CARD_ITEM_CLASS);

    cardItems.forEach(function (item) {
      var value = item.getAttribute('data-value');
      var variant = findVariantForCardValue(variants, cardOptionIndex, value, selectedMap);
      if (variant) updateCardItem(item, variant);
    });
  }

  function initContainer(container) {
    if (container.getAttribute('data-fossibot-card-init') === 'true') return;
    var cardOption = container.querySelector('[data-swatch-option]' + CARD_SELECTOR);
    if (!cardOption) return;

    var cardOptionIndex = parseInt(cardOption.getAttribute('data-id'), 10);
    if (isNaN(cardOptionIndex)) return;

    container.setAttribute('data-fossibot-card-init', 'true');
    refreshCardOption(container, cardOptionIndex);

    var swatchList = cardOption.querySelector('[data-swatch-list]');
    if (!swatchList) return;

    swatchList.addEventListener('click', function () {
      setTimeout(function () {
        refreshCardOption(container, cardOptionIndex);
      }, 0);
    });

    container.querySelectorAll('[data-swatch-option]').forEach(function (optionEl) {
      if (optionEl.getAttribute('data-fossibot-variant-card') === 'true') return;
      optionEl.addEventListener('click', function () {
        setTimeout(function () {
          refreshCardOption(container, cardOptionIndex);
        }, 50);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-callBackVariant]').forEach(initContainer);
  }

  window.FossibotVariantCard = {
    init: initAll,
    refresh: refreshCardOption
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  [300, 1000, 2500].forEach(function (delay) {
    setTimeout(initAll, delay);
  });

  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).on('variant:changed', function () {
      document.querySelectorAll('[data-callBackVariant]').forEach(function (container) {
        var cardOption = container.querySelector('[data-swatch-option]' + CARD_SELECTOR);
        if (!cardOption) return;
        var cardOptionIndex = parseInt(cardOption.getAttribute('data-id'), 10);
        refreshCardOption(container, cardOptionIndex);
      });
    });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
